import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const purchases = [{
  name: 'Florencia O.',
  location: 'Lashista',
  time: 'Hace 2 minutos'
}, {
  name: 'Camila M.',
  location: 'Manicurista',
  time: 'Hace 5 minutos'
}, {
  name: 'Lucía F.',
  location: 'Estilista',
  time: 'Hace 12 minutos'
}, {
  name: 'Martina G.',
  location: 'Coach',
  time: 'Hace 18 minutos'
}, {
  name: 'Sofía R.',
  location: 'Tienda Online',
  time: 'Hace 25 minutos'
}];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let showTimer: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 5 seconds
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    } else {
      // Show next after 15-25 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, nextDelay);
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [isVisible]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-361">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-362">
          <div className="bg-white border border-[#e8dfd0] rounded-xl shadow-xl p-4 pr-10 relative flex items-start gap-3" data-id="element-363">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-[#6b5d4f] hover:text-[#1a1611]" data-id="element-364">
              <X size={16} data-id="element-365" />
            </button>

            <div className="bg-[#c9a961]/10 p-2 rounded-full shrink-0 mt-0.5" data-id="element-366">
              <CheckCircle2 size={20} className="text-[#c9a961]" data-id="element-367" />
            </div>

            <div data-id="element-368">
              <p className="text-xs text-[#b8860b] font-black mb-1 uppercase tracking-wider" data-id="element-369">
                Compra verificada
              </p>
              <p className="text-sm text-[#1a1611] leading-tight mb-1 font-medium" data-id="element-370">
                <span className="font-black" data-id="element-371">{currentPurchase.name}</span> (
                {currentPurchase.location}) compró Megapack Negocio IA 🤖
              </p>
              <p className="text-xs text-[#6b5d4f] font-bold" data-id="element-372">
                {currentPurchase.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}